import { render, staticRenderFns } from "./rc-text-expand-button.vue?vue&type=template&id=5f383871&"
import script from "./rc-text-expand-button.vue?vue&type=script&lang=js&"
export * from "./rc-text-expand-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports